import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateGNodeBConfigParameters } from '@api/gNodeBConfigParameters';

import { IUpdateGNodeBConfigParametersDTO } from '@interfaces/crowdcell/dto/gNodeBConfigDTO';

import { ESnackbarTypes } from '@enums/common';

import { GNODEB_CONFIG_PARAMETERS, UPDATE_GNODEB_CONFIG_PARAMETERS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export interface IUpdateGNodeBConfigParametersReturned {
	isLoadingUpdateGNodeBConfigParameters: boolean;
	handleUpdateGNodeBConfigParameters: (data: IUpdateGNodeBConfigParametersDTO) => void;
}

export const useMutateUpdateGNodeBConfigParameters = (): IUpdateGNodeBConfigParametersReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleUpdateGNodeBConfigParameters,
		isLoading: isLoadingUpdateGNodeBConfigParameters,
	} = useMutation<IUpdateGNodeBConfigParametersDTO>({
		mutationKey: [UPDATE_GNODEB_CONFIG_PARAMETERS],
		mutationFn: updateGNodeBConfigParameters,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateGNodeBConfigParameters,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([GNODEB_CONFIG_PARAMETERS])];
		},
	});

	return { handleUpdateGNodeBConfigParameters, isLoadingUpdateGNodeBConfigParameters };
};
